import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import get from 'lodash/get';
import { Box } from 'roo-ui/components';
import { getPointsAmount, getTravelPassAmount, getPayableNowCashAmount, getPayableLaterCashAmount } from 'store/checkout/checkoutSelectors';
import { getPayableLaterDueDate } from 'store/quote/quoteSelectors';
import PaymentBreakdown from 'components/PaymentBreakdown';
import PriceBreakdownModal from 'pages/Checkout/PriceBreakdownModal';

const PriceDetails = ({ property, offer, checkIn, checkOut }) => {
  const { charges } = offer;
  const payableAtProperty = get(charges, 'payableAtProperty.total');
  const pointsAmount = useSelector(getPointsAmount);
  const travelPassAmount = useSelector(getTravelPassAmount);
  const payableNowCashAmount = useSelector(getPayableNowCashAmount);
  const payableLaterCashAmount = useSelector(getPayableLaterCashAmount);
  const payableLaterDueDate = useSelector(getPayableLaterDueDate);

  return (
    <Box p={[3, 6]} mt={[3, 6]} bg="lightBlue" borderRadius="default">
      <PaymentBreakdown
        payableNowCashAmount={payableNowCashAmount}
        payableLaterCashAmount={payableLaterCashAmount}
        payableLaterDueDate={payableLaterDueDate}
        pointsAmount={pointsAmount}
        travelPassAmount={travelPassAmount}
        payableAtProperty={payableAtProperty}
      />
      <PriceBreakdownModal property={property} offer={offer} checkIn={checkIn} checkOut={checkOut} />
    </Box>
  );
};

PriceDetails.propTypes = {
  property: PropTypes.shape({
    name: PropTypes.string.isRequired,
  }).isRequired,
  offer: PropTypes.shape({
    charges: PropTypes.shape({
      payableAtProperty: PropTypes.shape({
        amount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        currency: PropTypes.string,
      }).isRequired,
    }).isRequired,
  }).isRequired,
  checkIn: PropTypes.instanceOf(Date).isRequired,
  checkOut: PropTypes.instanceOf(Date).isRequired,
};

export default PriceDetails;
